import React from 'react';
import { FormattedMessage } from 'react-intl';

import { UIDAPresentationTypeEnum } from '@kaltura-ott/tvpil';

import MainLayout from 'components/presenters/layouts/main/MainLayout';
import NoContent from 'components/widgets/NoContent/NoContent';
import routes from 'routesPaths';

import GridUpdatingHook from '../components/GridUpdatingHook/GridUpdatingHook';
import { COMPONENT_NAME } from '../constants';

import { SeriesCatchUpGridContainer } from './components/SeriesCatchUpGridContainer/SeriesCatchUpGridContainer';
import { useSeriesCatchUpGrid } from './hooks/useSeriesCatchUpGrid/useSeriesCatchUpGrid';

import styles from './SeriesCatchUpGrid.module.scss';

function SeriesCatchUpGrid() {
  const type = UIDAPresentationTypeEnum.series_catch_up;

  const { settings, data, wrapperRef, notValidPageTitle, setForceUpdate } = useSeriesCatchUpGrid();

  const isDataMissing = !settings || !data;

  if (isDataMissing) {
    return (
      <MainLayout>
        <NoContent title={notValidPageTitle} />
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <GridUpdatingHook setForceUpdate={setForceUpdate} path={routes.seriesCatchUpGrid.path} />
      <div ref={wrapperRef} className={styles.wrapper}>
        <FormattedMessage
          defaultMessage={settings.title}
          id={`${COMPONENT_NAME}.title.${settings.title}`}
          tagName='h3'
        />

        <SeriesCatchUpGridContainer data={data} type={type} settings={settings} />
      </div>
    </MainLayout>
  );
}

export default React.memo(SeriesCatchUpGrid);
